import { render, staticRenderFns } from "./profitability1.vue?vue&type=template&id=68d6fcb6&scoped=true"
import script from "./profitability1.vue?vue&type=script&lang=js"
export * from "./profitability1.vue?vue&type=script&lang=js"
import style0 from "./profitability1.vue?vue&type=style&index=0&id=68d6fcb6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d6fcb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\sseinfo\\src_finreport_xc\\tdinfo-szs-finreport-pc-\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68d6fcb6')) {
      api.createRecord('68d6fcb6', component.options)
    } else {
      api.reload('68d6fcb6', component.options)
    }
    module.hot.accept("./profitability1.vue?vue&type=template&id=68d6fcb6&scoped=true", function () {
      api.rerender('68d6fcb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profitability1.vue"
export default component.exports